import {NaniumObject, RequestType, Type} from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { VideoFile } from "../../entities/video-file.entity";

export class VideoQueryRequestBody extends NaniumObject<VideoQueryRequestBody> {
	@Type(Array, String) idList?: string[];
}

@RequestType({
	responseType: VideoFile,
	genericTypes: { TRequestBody: VideoQueryRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class VideoQueryRequest extends ServiceRequestBase<VideoQueryRequestBody, VideoFile[]> {
	static serviceName: string = 'NaniumDemo:video/query';
}
